import { useMarketStatus } from '@ui/features/Trade/hooks/useMarketStatus';
import { Box } from 'styled-system/jsx';

import { MarketStatusMessage } from '../MarketStatusMessage';
import { useIsLong } from '../store/useIsLong';

export const FooterMarketStatusMessage = () => {
  const status = useMarketStatus();
  const isLong = useIsLong((s) => s._persistValue);

  return (
    <Box
      px={4}
      pb={3}
      _empty={{
        pb: 0,
      }}
    >
      <MarketStatusMessage isLong={isLong} status={status} />
    </Box>
  );
};
